// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"06aae282","594":"25f7100c"}[chunkId] + ".chunk.js";
};